module.exports = __webpack_public_path__ + "img/logo_mono_cp.7b9df5cf.png";